export const ONLY_LETTERS = /^(?! )[A-Za-zÀ-ÖØ-öø-ÿ]+(?: [A-Za-zÀ-ÖØ-öø-ÿ]+)*$/
export const ONLY_NAMES_PEOPLE_LETTERS = /^(?! )[A-Za-zÀ-ÖØ-öø-ÿ'][A-Za-zÀ-ÖØ-öø-ÿ' -]*(?:[A-Za-zÀ-ÖØ-öø-ÿ'])?$/
